import { useState } from "react";
import API from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { CalendarBlank, Copy, ArrowsClockwise } from "@phosphor-icons/react";
import { CardShell } from "./shared";

export default function IcalCard({ item, onChange }) {
  const [url, setUrl] = useState(item?.extra?.feed_url || "");
  const [busy, setBusy] = useState(false);
  const [confirming, setConfirming] = useState(false);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); }
    catch { window.prompt("Copy this link:", url); }
    toast.success("Feed link copied — paste it into your calendar app as a subscription");
  };

  const rotate = async () => {
    if (!confirming) { setConfirming(true); toast("Click again to confirm — the old link stops working immediately"); return; }
    setConfirming(false);
    setBusy(true);
    try { const { data } = await API.post("/integrations/ical/rotate"); setUrl(data.feed_url); toast.success("New feed link generated"); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not rotate the link"); }
    finally { setBusy(false); }
  };

  return (
    <CardShell title="Calendar feed (iCal)" icon={<CalendarBlank size={20} weight="duotone" className="text-emerald-600" />} item={{ ...item, connection: { status: "connected" } }} testid="integration-ical">
      <div className="space-y-2">
        <div className="flex items-center gap-2 rounded-md bg-muted/40 p-2">
          <code className="text-[10px] break-all flex-1" data-testid="ical-feed-url">{url}</code>
          <Button size="icon" variant="ghost" className="h-6 w-6" onClick={copy} data-testid="copy-ical-btn"><Copy size={12} /></Button>
        </div>
        <p className="text-[10px] text-muted-foreground">Apple Calendar: File → New Calendar Subscription. Google: Other calendars → From URL. Outlook: Add calendar → Subscribe from web. Updates every 15 minutes; read-only.</p>
        <Button size="sm" variant="ghost" onClick={rotate} disabled={busy} className="gap-1 text-xs" data-testid="ical-rotate-btn"><ArrowsClockwise size={12} /> {confirming ? "Confirm new link" : "Generate new link"}</Button>
      </div>
    </CardShell>
  );
}
